document.addEventListener("DOMContentLoaded", function () {
    const firstVisitModal = document.getElementById("first-visit");

    if (firstVisitModal && !document.cookie.includes("visited=true")) {

        const modal = new bootstrap.Modal(firstVisitModal);
        modal.show();
        document.cookie = "visited=true; max-age=31536000; path=/";

        firstVisitModal.addEventListener("hidden.bs.modal", function (e) {
            modal.dispose();
            firstVisitModal.remove();

        });
    }

    const saveDeliveryCostsInfoModal = document.getElementById("saveCostsInfoModal");
    const saveDeliveryCostsButton = document.querySelectorAll(".save-costs-info");
    if (saveDeliveryCostsInfoModal && saveDeliveryCostsButton.length > 0) {
        const modal = new bootstrap.Modal(saveDeliveryCostsInfoModal);
        saveDeliveryCostsButton.forEach((button) => {
            button.addEventListener("click", function (e) {
                e.preventDefault();
                modal.show();
            });
        });
    }

    const saveDeliveryCostsConfirmationModal = document.getElementById("saveCostsConfirmationModal")
    const saveDeliveryCostsConfirmationButton = document.querySelectorAll(".save-costs-confirmation");
    if (saveDeliveryCostsConfirmationModal && saveDeliveryCostsConfirmationButton.length > 0) {
        const modal = new bootstrap.Modal(saveDeliveryCostsConfirmationModal);
        saveDeliveryCostsConfirmationButton.forEach((button) => {
            button.addEventListener("click", function (e) {
                e.preventDefault();

                const closestDateEl = button.closest(".meal-wrap-date");
                const deliveryDate = closestDateEl.getAttribute("data-date");
                saveDeliveryCostsConfirmationModal.setAttribute("data-delivery-date", deliveryDate);
                modal.show();
            });
        });
    }
});